import { createFileRoute } from "@tanstack/react-router";
import { DiscoveryStep } from "~/components/ui/discovery-step";
import { FormField } from "~/components/ui/form-field";
import { LanguageSelect } from "~/components/language-select";
import { useDiscoveryForm } from "~/lib/hooks/use-discovery-form";
import { createNoIndexMeta } from "~/lib/shared/meta";
import {
  PreferredLanguageSchema,
  preferredLanguagesStep,
} from "~/lib/schemas/coach-discovery";

export const Route = createFileRoute("/_public/discovery/steps/9/")({
  head: () =>
    createNoIndexMeta(
      "Step 9: Language Preferences – Dream Coach Match",
      "Set your preferred coaching languages in our discovery process",
    ),
  component: Step9Component,
});

function Step9Component() {
  const { form, handleNextStep, handlePreviousStep } = useDiscoveryForm(
    PreferredLanguageSchema,
    9,
  );
  const { register, handleSubmit, formState, watch } = form;
  const { errors, isSubmitting, isValid } = formState;

  const onSubmit = (_data: { preferredLanguages?: string[] }) => {
    handleNextStep();
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <DiscoveryStep.Title title={preferredLanguagesStep.title} />
      <DiscoveryStep.Card>
        <FormField error={errors.preferredLanguages?.message}>
          <LanguageSelect
            field={{
              name: "preferredLanguages",
              value: watch("preferredLanguages"),
            }}
            props={register("preferredLanguages")}
          />
        </FormField>
      </DiscoveryStep.Card>
      <DiscoveryStep.Control
        prev={handlePreviousStep}
        type="submit"
        disabled={!isValid}
        loading={isSubmitting}
      />
    </form>
  );
}
